<!-- contact-sideswipe component -->
<div class="contact-sideswipe {{this.isContactOpen ? 'open' : 'close'}}">
    <div class="contact-label" 
        (click)="this.openContact()" 
        (keydown.enter)="this.openContact()" 
        (keydown.Space)="this.openContact()" 
        tabindex="3"
        style="cursor: pointer;"
    >
        <span>Contact</span>
    </div>
    <div class="contact-info">
        <h4>Need Help?</h4>
        <p>Call: 855.966.9435<br/>
            Email: sales@nowcorp.com</p>
    </div>
</div>